import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../atoms/Image/Image';
import { ImagesPropType, ObjectPropsPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import BasicCarousel from '../../../foundation/components/Carousel/variants/BasicCarousel/BasicCarousel';
import { getItemKey } from '../../../foundation/services/props';
import { ChildrenPropType } from '../../../foundation/types/component';
import './BackgroundImages.less';
var defaultProps = {
  content: null,
  children: null,
  parentClassName: '',
  imageClassName: '',
  carouselProps: {},
  imageProps: {}
};
export default function BackgroundImages(_ref) {
  var _classNames;
  var images = _ref.images,
    content = _ref.content,
    children = _ref.children,
    parentClassName = _ref.parentClassName,
    imageClassName = _ref.imageClassName,
    carouselProps = _ref.carouselProps,
    imageProps = _ref.imageProps;
  var finalImages = images || [];
  var multipleImages = finalImages.length > 1;
  var noImage = _isEmpty(finalImages);
  var singleImage = finalImages.length === 1;
  var finalClassNames = classNames((_classNames = {
    'background-images': true
  }, _defineProperty(_classNames, parentClassName, parentClassName), _defineProperty(_classNames, "multiple", multipleImages), _defineProperty(_classNames, "single", singleImage), _defineProperty(_classNames, 'no-image', noImage), _classNames));
  var displayCarousel = multipleImages || singleImage;
  var finalContent = content || children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, displayCarousel && /*#__PURE__*/React.createElement(BasicCarousel, _extends({
    className: finalClassNames,
    size: 1,
    grouping: 1,
    displayIndicators: true,
    displayPlayPauseButton: false,
    autoScroll: false,
    animation: {
      name: 'blur',
      duration: 200,
      transitionProps: {
        preAnimating: {
          opacity: 0.99,
          blur: '2px'
        },
        animating: {
          opacity: 0.99,
          blur: '2px'
        }
      },
      targetSelector: '> .image::before, > .image::after'
    },
    items: finalImages.map(function (image) {
      var key = getItemKey(image, '_id');
      return /*#__PURE__*/React.createElement(Image, _extends({
        key: key,
        src: _get(image, 'src') || image,
        altText: _get(image, 'altText', ''),
        className: imageClassName,
        background: true
      }, imageProps || {}), finalContent);
    })
  }, carouselProps || {})), noImage && !_isEmpty(finalContent) && /*#__PURE__*/React.createElement(Image, _extends({
    background: true,
    className: finalClassNames
  }, imageProps || {}), finalContent));
}
BackgroundImages.defaultProps = defaultProps;